module.exports = __webpack_public_path__ + "img/introducePageTwo_show_four.d415b5af.jpg";